import { Feature } from '@frontend/functionality/types';
import { CommonMessage } from '@frontend/lang';

export function getVendingTransactionTypeDisplay(feature: Feature | null): React.ReactNode {
    switch (feature) {
        case Feature.OUTBOUND_TRANSACTION:
            return CommonMessage.OBJECTS.CONSUMPTION.DEFAULT;
        case Feature.INBOUND_TRANSACTION:
            return CommonMessage.OBJECTS.REPLENISHMENT.DEFAULT;
        case Feature.RETURN_TRANSACTION:
            return CommonMessage.OBJECTS.RETURN.DEFAULT;
        case Feature.RECYCLE_TRANSACTION:
            return CommonMessage.OBJECTS.RECYCLE.DEFAULT;
        default:
            return CommonMessage.OBJECTS.UNKNOWN.DEFAULT;
    }
}
